import { j as o } from "../../jsx-runtime.BREq8dyb.js";
import { Box as s, Slider as f } from "@mui/joy";
import { useState as i } from "react";
import { C as h } from "../../react-easy-crop.vTvUgYyM.js";
const y = ({
  imageSrc: e,
  onCropComplete: a,
  wrapperSx: p,
  aspectRatio: x = 1,
  height: l = 500,
  width: m = 500
}) => {
  const [c, d] = i({
    x: 0,
    y: 0
  }), [r, t] = i(1);
  return e ? /* @__PURE__ */ o.jsxs(s, { sx: {
    alignItems: "center",
    boxSizing: "content-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    ...p
  }, children: [
    /* @__PURE__ */ o.jsx(s, { sx: {
      "& .reactEasyCrop_CropArea::after": {
        borderColor: "rgb(78 69 69 / 90%)"
      },
      "& .reactEasyCrop_CropArea::before": {
        borderColor: "rgb(78 69 69 / 90%)"
      },
      border: "1px solid black",
      height: `${l}px`,
      overflow: "hidden",
      position: "relative",
      width: `${m}px`
    }, children: /* @__PURE__ */ o.jsx(h, { aspect: x, crop: c, image: e, onCropChange: d, onCropComplete: a, onZoomChange: t, style: {
      cropAreaStyle: {
        border: "none",
        boxShadow: "none"
      }
    }, zoom: r }) }),
    /* @__PURE__ */ o.jsx(f, { max: 3, min: 1, onChange: (n, C) => t(C), size: "sm", step: 0.1, sx: (n) => ({
      maxWidth: "250px",
      mt: n.spacing(1),
      width: "75%"
    }), value: r })
  ] }) : null;
};
export {
  y as default
};
//# sourceMappingURL=DqImageCropper.js.map
